import { bootstrapWorkspace as bootstrap, initializeDatabase as initialize } from "./bootstrap";
import { db as singletonDatabase, type DuaWorkspaceDatabase } from "./database";
import { createRepositories } from "./repositories";

export * from "./bootstrap";
export * from "./database";
export * from "./repositories";

export const db = singletonDatabase;

const repositories = createRepositories(db);

export const personalDuaRepository = repositories.personalDuas;
export const collectionRepository = repositories.collections;
export const tagRepository = repositories.tags;
export const personRepository = repositories.people;
export const reflectionRepository = repositories.reflections;
export const sessionRepository = repositories.sessions;
export const memorisationRepository = repositories.memorisation;
export const settingsRepository = repositories.settings;
export const metadataRepository = repositories.metadata;

export function bootstrapWorkspace(
  database: DuaWorkspaceDatabase = db,
  options: Parameters<typeof bootstrap>[1] = {},
): Promise<void> {
  return bootstrap(database, options);
}

export function initializeDatabase(
  database: DuaWorkspaceDatabase = db,
  options: Parameters<typeof initialize>[1] = {},
): Promise<DuaWorkspaceDatabase> {
  return initialize(database, options);
}
